export var MuiOutlinedInputProps = {};
export var getMuiOutlinedInputOverrides = function (_a) {
    var spacing = _a.spacing;
    return ({
        adornedStart: {
            paddingLeft: 0,
        },
        inputAdornedStart: {
            paddingLeft: spacing(1),
        },
    });
};
//# sourceMappingURL=MuiOutlinedInput.js.map